import store from '../store/index.js'
//通过自定义全局指令，控制增删改按钮的隐藏
let menu_rights = null;
//判断权限！解决一进页面不能里面有数据
function checkArray(key) {
  try {
    if (!menu_rights) {
      menu_rights = store.getters.menusList.map((obj) => obj.pid);
    }
    return menu_rights.some((item) => item === key);
  } catch {
    return false
  }
}

//全局指令 v-directiive
const Dclrights = {};
Dclrights.install = (Vue) => {
  Vue.directive("Dclrights", {
    inserted(el, binding) {
      let Dclrights = binding.value; // 获取到 v-permission的值
      if (Dclrights) {
        let hasPermission = checkArray(Dclrights);
        if (!hasPermission) {
          // 没有权限 移除Dom元素
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    },
  });
};
export default Dclrights